const externalRoutes = [
    // Внешние формы
    {
        path: '/external',
        component: () => import('layouts/ExternalLayout.vue'),
        children: [
            {
                path: 'course/:id',
                component: () => import('pages/sot.bot.admin/courses/CoursesIndex.vue'),
            },
            {
                path: 'applications',
                component: () => import('pages/sot.bot.admin/applications30/Applications30Index.vue'),
            },
            {
                path: 'webinars-schedule',
                component: () => import('pages/external/WebinarsSchedulePage.vue'),
            },
            {
                path: 'webinars',
                component: () => import('pages/sot.bot.admin/webinars/WebinarsPage.vue'),
            },
            {
                path: 'webinars/:id',
                component: () => import('pages/sot.bot.admin/webinars/WebinarDetail.vue'),
            },
            { path: 'exercises', component: () => import('pages/sot.bot.admin/exercises/ExercisesPage.vue') },
            // Старая лента заданий — для сравнения аналитиками, удалить вместе со старой реализацией
            { path: 'exercises-old', component: () => import('pages/sot.bot.admin/taskExercise/ExerciseFeed.vue') },
            { path: 'chat', component: () => import('pages/sot.bot.admin/operators/OperatorChat.vue') },
            { path: 'media-service', component: () => import('pages/sot.bot.admin/library/MediaService.vue') }, // медиасервис
            { path: 'student', component: () => import('pages/external/UserDialogNewExternal.vue') }, // Диалоговое окно обучаемого
            { path: 'storage', component: () => import('pages/sot.bot.admin/storage30/Storage30Index.vue') },
            { path: 'documents', component: () => import('pages/sot.bot.admin/documents20/Documents20Index.vue') },
            { path: 'desktop/:id?', component: () => import('pages/sot.bot.admin/desktop/AdminDesktop.vue') },
        ],
    },
];

export default externalRoutes;
